// extracted by mini-css-extract-plugin
module.exports = {"pens":"_7cf59c1"};